import React, { useState } from 'react';
import { Spin, Alert, message } from 'antd';
import { usePWJ310Query } from './hooks/usePWJ310Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pwj310Api';
import './PWJ310Form.css';

const PWJ310Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePWJ310Query();

  const [materialFrom, setMaterialFrom] = useState('');
  const [materialTo, setMaterialTo] = useState('');
  const [fabricFrom, setFabricFrom] = useState('');
  const [fabricTo, setFabricTo] = useState('');
  const [check1, setCheck1] = useState(true);
  const [check2, setCheck2] = useState(false);

  const handleQuery = () => {
    // BR-PRINT-01: at least one checkbox must be selected
    if (!check1 && !check2) {
      message.warning('請至少勾選一項印表選擇（原料代號別 / 工廠布號別）');
      return;
    }

    // BR-PRINT-04: range validation
    const mFrom = materialFrom.trim();
    const mTo = materialTo.trim();
    if (mFrom && mTo && mTo < mFrom) {
      message.warning('原料代號不可後者小於前者！');
      return;
    }

    const fFrom = fabricFrom.trim();
    const fTo = fabricTo.trim();
    if (fFrom && fTo && fTo < fFrom) {
      message.warning('工廠布號不可後者小於前者！');
      return;
    }

    const req: QueryRequest = {
      materialFrom: mFrom,
      materialTo: mTo,
      fabricFrom: fFrom,
      fabricTo: fTo,
      check1,
      check2,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pwj310-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          原料代號與工廠布號對照表 (J3101)
        </h2>

        <QueryParams
          materialFrom={materialFrom}
          materialTo={materialTo}
          fabricFrom={fabricFrom}
          fabricTo={fabricTo}
          check1={check1}
          check2={check2}
          loading={loading}
          onMaterialFromChange={setMaterialFrom}
          onMaterialToChange={setMaterialTo}
          onFabricFromChange={setFabricFrom}
          onFabricToChange={setFabricTo}
          onCheck1Change={setCheck1}
          onCheck2Change={setCheck2}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的原料或工廠布號資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PWJ310Form;
